<template>
  <div>
    <v-card outlined class="app-card">
      <v-card-title class="app-card-title">
        Autorização
        <v-btn
          depressed
          small
          color="primary"
          outlined
          v-on:click="voltar()"
          class="btn-voltar"
          >Voltar</v-btn
        >
      </v-card-title>
      <v-card-text v-if="veiculo.selected.placa" class="app-card-content">
        <v-row no-gutters>
          <v-col :md="4" :sm="4" :xs="12" cols="12">
            <strong class="info-text">
              Nº Licença:
              <em>{{ veiculo.selected.numeroLicenca }}</em>
            </strong>
          </v-col>
          <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2 text-md-left">
            <strong class="info-text">
              Placa:
              <em>{{ veiculo.selected.placa }}</em>
            </strong>
          </v-col>
          <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2 text-md-left">
            <strong class="info-text">
              Período de Validade:
              <em>{{ veiculo.selected.periodoValidade }}</em>
            </strong>
          </v-col>
          <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2 text-md-left">
            <strong class="info-text">
              Tipo de Licença:
              <em>{{ veiculo.selected.tipolicenca }}</em>
            </strong>
          </v-col>
          <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2 text-md-left">
            <strong class="info-text">
              Situação:
              <em>{{ veiculo.selected.situacaoDescricao }}</em>
            </strong>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card outlined class="app-card">
      <v-card-title class="app-card-title">
        Viagens
        <v-btn
          depressed
          color="primary"
          class="white--text mt-5 btn-nova"
          @click="dialog.dialogFormViagemOpen = true"
        >
          <v-icon>add</v-icon>Nova Viagem
        </v-btn>
      </v-card-title>
      <v-card-text class="app-card-content">
        <v-row no-gutters>
          <v-col :md="12" :sm="12" :xs="12" cols="12">
            <v-alert type="warning" text outlined>
              Para imprimir uma Autorização de Fretamento, deverá existir pelo
              menos uma viagem cadastrada.
            </v-alert>
          </v-col>
          <v-col :md="12" :sm="12" :xs="12" cols="12" class="mt-5">
            <v-layout v-resize="onResize" column>
              <v-data-table
                :headers="table.header"
                :items="table.content"
                :loading="table.isLoading"
                item-key="name"
                :hide-default-header="isMobile"
                :class="{ mobile: isMobile }"
              >
                <template v-if="table.content.length" v-slot:body="{ items }">
                  <tbody>
                    <template v-for="item in items">
                      <tr v-if="!isMobile" :key="item.numero">
                        <td>{{ item.numeroViagem }}</td>
                        <td>
                          {{ item.inicioVigencia }} a {{ item.fimVigencia }}
                        </td>
                        <td>
                          {{ item.horaOrigem }} /
                          {{ item.localidadeOrigem.nome }}
                        </td>
                        <td>
                          {{ item.horaDestino }} /
                          {{ item.localidadeDestino.nome }}
                        </td>
                        <td>{{ item.situacaoDescricao }}</td>
                        <td>
                          <v-btn-toggle v-if="item.situacaoId !== 3">
                            <v-btn
                              @click="getImprimirLicenca(item.id)"
                              small
                              title="Imprimir Autorização"
                              color="#FFA000"
                            >
                              <v-icon size="15px" class="white--text"
                                >print</v-icon
                              >
                            </v-btn>
                            <v-btn
                              @click="editarViagem(item)"
                              small
                              title="Editar Viagem"
                              color="primary"
                            >
                              <v-icon size="15px" class="white--text"
                                >create</v-icon
                              >
                            </v-btn>
                            <v-btn
                              @click="openDialogAdicionarPassageiro(item)"
                              small
                              title="Adicionar Passageiro"
                              color="success"
                            >
                              <v-icon size="15px" class="white--text"
                                >person_add</v-icon
                              >
                            </v-btn>
                            <v-btn
                              @click="openDialogExclusao(item)"
                              small
                              title="Remover Viagem"
                              color="error"
                            >
                              <v-icon size="15px" class="white--text"
                                >delete</v-icon
                              >
                            </v-btn>
                          </v-btn-toggle>
                        </td>
                      </tr>
                      <tr v-else :key="item.numero">
                        <td class="th-mobile">
                          <ul class="flex-content">
                            <li class="flex-item">
                              <strong>Nº Viagem</strong>
                              <span>{{ item.numeroViagem }}</span>
                            </li>
                            <li class="flex-item">
                              <strong>Período de Viagem</strong>
                              <span>
                                {{ item.inicioVigencia }} a
                                {{ item.fimVigencia }}
                              </span>
                            </li>
                            <li class="flex-item">
                              <strong>Hora saída/Origem</strong>
                              <span>
                                {{ item.horaOrigem }} /
                                {{ item.localidadeOrigem.nome }}
                              </span>
                            </li>
                            <li class="flex-item">
                              <strong>Hora saída/Destino</strong>
                              <span>
                                {{ item.horaDestino }} /
                                {{ item.localidadeDestino.nome }}
                              </span>
                            </li>
                            <li class="flex-item">
                              <strong>Situação da Viagem</strong>
                              <span>{{ item.situacaoDescricao }}</span>
                            </li>
                            <li class="flex-item">
                              <strong>Ações</strong>
                              <v-btn-toggle v-if="item.situacaoId !== 3">
                                <v-btn
                                  @click="getImprimirLicenca(item.id)"
                                  small
                                  title="Imprimir Autorização"
                                  color="#FFA000"
                                >
                                  <v-icon size="15px" class="white--text"
                                    >print</v-icon
                                  >
                                </v-btn>
                                <v-btn
                                  @click="editarViagem(item)"
                                  small
                                  title="Editar Viagem"
                                  color="primary"
                                >
                                  <v-icon size="15px" class="white--text"
                                    >create</v-icon
                                  >
                                </v-btn>
                                <v-btn
                                  @click="openDialogAdicionarPassageiro(item)"
                                  small
                                  title="Adicionar Viagem"
                                  color="primary"
                                >
                                  <v-icon size="15px" class="white--text"
                                    >person_add</v-icon
                                  >
                                </v-btn>
                                <v-btn
                                  @click="openDialogExclusao(item)"
                                  small
                                  title="Remover Viagem"
                                  color="error"
                                >
                                  <v-icon size="15px" class="white--text"
                                    >delete</v-icon
                                  >
                                </v-btn>
                              </v-btn-toggle>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>

                <template v-if="table.isLoading" v-slot:progress>
                  <v-progress-linear indeterminate></v-progress-linear>
                </template>

                <template v-if="!table.content.length" v-slot:no-data
                  >Não a itens disponíveis</template
                >
              </v-data-table>
            </v-layout>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog
      v-if="dialog.dialogFormViagemOpen"
      v-model="dialog.dialogFormViagemOpen"
      width="700"
      persistent
    >
      <v-card
        class="app-card app-card--without-border app-card--without-margin-bottom"
      >
        <v-card-title class="app-card-title" primary-title
          >Nova Viagem</v-card-title
        >

        <ViagemForm
          @closeDialogFormViagem="openDialogFormViagem($event)"
          :viagemEdit="viagem.selected"
          :autorizacaoId="viagem.autorizacaoId"
          @recarregarListaViagens="getAllViagens"
        />
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="dialog.modalAdicionarPassageiroOpen"
      v-model="dialog.modalAdicionarPassageiroOpen"
      persistent
      width="1100"
    >
      <v-card
        class="app-card app-card--without-border app-card--without-margin-bottom"
      >
        <v-card-title class="app-card-title" primary-title
          >Adicionar Passageiro</v-card-title
        >
        <PassegeiroForm
          :viagemDB="viagem.selected"
          @closeDialogPassageiroForm="closeDialogFormPassageiro()"
          @recarregarListaViagens="getAllViagens"
        />
      </v-card>
    </v-dialog>

    <!-- DIALOG DA CONFIRMAÇÃO DE EXCLUSAO DE VIAGEM -->
    <v-dialog
      v-model="dialog.exclusaoConfirmacaoOpen"
      persistent
      max-width="370"
    >
      <v-card>
        <v-card-title>Confirma a exclusão da Viagem?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialog.exclusaoConfirmacaoOpen = false"
            depressed
            color="error"
            >Cancelar</v-btn
          >
          <v-btn
            @click="removeViagem"
            depressed
            color="#3eb355"
            class="white--text"
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM DIALOG EXCLUSAO VIAGEM -->

    <v-dialog
      v-model="dialog.imprmirBoletoOpen"
      persistent
      max-width="750"
      style="max-height: 90%"
    >
      <v-card>
        <v-card-title>Boleto Autorização</v-card-title>
        <v-card-text>
          <iframe
            style="width: 100%; height: 400px;"
            :src="src"
            frameborder="0"
          ></iframe>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialog.imprmirBoletoOpen = false"
            depressed
            color="error"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- SPINNER DE LOAD -->
    <v-overlay :value="showOverlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import ViagemForm from "../vigem/ViagemForm";
import LicencaEspecialService from "@/services/licencaEspecial.service";
import TransportadoraStore from "@/store/modules/transportadora";
import PassegeiroForm from "../vigem/PassageiroForm";
import VeiculoService from "@/services/veiculo.service";
import ViagemService from "@/services/viagem.service";
import GlobalStore from "@/store/modules/global";

export default {
  components: {
    ViagemForm,
    PassegeiroForm
  },
  data() {
    return {
      isMobile: false,
      veiculo: {
        selected: {}
      },
      src: null,
      viagem: {
        selected: {}
      },
      dialog: {
        exclusaoConfirmacaoOpen: false,
        dialogFormViagemOpen: false,
        imprmirBoletoOpen: false,
        modalAdicionarPassageiroOpen: false
      },
      formPassageiro: [],
      openModalAdicionarPassageiro: false,
      showOverlay: false,
      table: {
        header: [
          { text: "Nº Viagem" },
          { text: "Período de Viagem" },
          { text: "Hora saída/Origem" },
          { text: "Hora saída/Destino" },
          { text: "Situação da Viagem" },
          { text: "Ações" }
        ],
        content: [],
        isLoading: false
      }
    };
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    getAllAutorizacoesFretamentos() {
      this.showOverlay = true;
      const { autorizacaoId } = this.$route.params;
      LicencaEspecialService.findAutorizacaoById(autorizacaoId).subscribe(
        response => {
          this.showOverlay = false;
          this.veiculo.selected = response;
        },
        err => {
          this.showOverlay = false;
          this.exibirMensagem(
            "Erro ao buscar autorização de fretamento",
            "error"
          );
        }
      );
    },
    getAllViagens() {
      this.showOverlay = true;
      const { autorizacaoId } = this.$route.params;
      ViagemService.getAllViagens(autorizacaoId).subscribe(
        response => {
          this.showOverlay = false;
          const { viagens } = response;
          this.table.content = viagens;
        },
        err => {
          this.showOverlay = false;
          this.exibirMensagem("Erro ao listar viagens", "error");
        }
      );
    },
    voltar() {
      this.$router.back();
    },
    getCurrentVeiculo() {
      VeiculoService.findById(this.veiculo.id).subscribe(
        response => {
          this.veiculo.selected = response.veiculo[0];
        },
        err => {
          this.exibirMensagem("Erro ao obter veículo", "error");
        }
      );
    },
    getImprimirLicenca(viagemId) {
      LicencaEspecialService.imprimirLicençaViagem(viagemId).subscribe(
        response => {
          this.dialog.imprmirBoletoOpen = true;
          let {
            imprimirLicencaViagem: { content }
          } = response;
          this.src = "data:application/pdf;base64, " + content;
        },
        err => {
          this.exibirMensagem("Erro ao obter veículo", "error");
        }
      );
    },
    openDialogExclusao(item) {
      this.dialog.exclusaoConfirmacaoOpen = true;
      this.viagem.selected.id = item.id;
    },
    openDialogFormViagem(event) {
      this.dialog.dialogFormViagemOpen = false;
      this.viagem.selected = {};
    },
    closeDialogFormPassageiro() {
      this.dialog.modalAdicionarPassageiroOpen = false;
      this.viagem.selected = {};
    },
    openDialogAdicionarPassageiro(item) {
      this.dialog.modalAdicionarPassageiroOpen = true;
      this.viagem.selected = item;
    },
    removeViagem() {
      ViagemService.removeViagem(this.viagem.selected.id).subscribe(
        response => {
          this.dialog.exclusaoConfirmacaoOpen = false;
          this.getAllViagens();
          this.viagem.selected = {};
          this.exibirMensagem("Operação realizada com sucesso", "success");
        },
        err => {
          this.showOverlay = false;
          this.exibirMensagem("Erro ao excluir vaigem", "error");
          
        }
      );
    },
    editarViagem(item) {
      this.dialog.dialogFormViagemOpen = true;
      this.viagem.selected = item;
    },
    exibirMensagem(mensagem, tipoMensagem) {
      GlobalStore.setSnackBar({
        show: true,
        message: mensagem,
        type: tipoMensagem,
        timeout: 3000
      });
    }
  },
  created() {
    this.veiculo.id = this.$route.params.veiculoId;
    this.veiculo.autorizacaoId = this.$route.params.autorizacaoId;
    this.veiculo.veiculoTransportadoraId = this.$route.params.veiculoTransportadoraId;

    this.viagem.autorizacaoId = this.$route.params.autorizacaoId;

    this.getAllAutorizacoesFretamentos();
    this.getAllViagens();
  }
};
</script>

<style lang="scss" scoped>
.btn-nova {
  position: absolute;
  right: 17px;
  top: -12px;
}
.btn-voltar {
  position: absolute;
  right: 20px;
}
.no-scroll {
  max-height: 100%;
}
</style>
